import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import AppLayout from "./components/AppLayout";
import Dashboard from "./pages/Dashboard";
import BookDetail from "./pages/BookDetail";
import SeriesPage from "./pages/SeriesPage";
import UsagePage from "./pages/UsagePage";
import SettingsPage from "./pages/SettingsPage";
import BookPicker from "./pages/BookPicker";
import PlannedPage from "./pages/PlannedPage";
import ContinuityPage from "./pages/ContinuityPage";
import BillingPage, { PaymentResult } from "./pages/BillingPage";
import Showcase from "./pages/Showcase";
import ShowcaseBook from "./pages/ShowcaseBook";
import ComicReader from "./pages/ComicReader";
import ShowcaseProfile from "./pages/ShowcaseProfile";
import ReadersPage from "./pages/ReadersPage";
import TrashPage from "./pages/TrashPage";
import SupportPage from "./pages/SupportPage";
import Unsubscribe from "./pages/Unsubscribe";
import PublishedCard from "./pages/PublishedCard";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400" data-testid="auth-loading">Checking your session…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !["owner", "admin"].includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/authors" element={<Showcase />} />
      <Route path="/authors/:slug" element={<ShowcaseBook />} />
      <Route path="/authors/:slug/read" element={<ComicReader />} />
      <Route path="/unsubscribe" element={<Unsubscribe />} />
      <Route path="/published/:token" element={<PublishedCard />} />
      <Route path="/payment/success" element={<PaymentResult ok />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route path="/app" element={<Protected><AppLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="books/:id" element={<BookDetail />} />
        <Route path="series" element={<SeriesPage />} />
        <Route path="studio/:tab" element={<BookPicker />} />
        <Route path="planned/:key" element={<PlannedPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="continuity" element={<ContinuityPage />} />
        <Route path="usage" element={<UsagePage />} />
        <Route path="showcase" element={<ShowcaseProfile />} />
        <Route path="readers" element={<ReadersPage />} />
        <Route path="trash" element={<TrashPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="settings" element={<Protected admin><SettingsPage /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
